var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.00001.666016c4.60329 0 8.33499 3.731664 8.33499 8.335004 0 4.60248-3.7317 8.33418-8.33499 8.33418-4.60333 0-8.335001-3.7317-8.335001-8.33418 0-4.60334 3.731671-8.335004 8.335001-8.335004zm-.00333 6.875004c-.20423.00027-.40124.07554-.55363.21149-.15239.13596-.24956.32314-.27304.52601l-.00583.09666.0025 4.58502.00583.0975c.02349.2032.12093.3907.27374.5267.15282.1361.35033.2111.55492.2109s.40195-.0756.55449-.212c.15254-.1363.2496-.324.27268-.5273l.005-.0975-.0025-4.58415-.00583-.0975c-.02409-.2027-.12174-.38951-.27442-.52499-.15269-.13548-.34979-.21021-.55391-.21001zm.00333-3.12417c-.2766 0-.54187.10988-.73745.30546-.19559.19559-.30547.46086-.30547.73746 0 .27659.10988.54186.30547.73745.19558.19558.46085.30546.73745.30546s.54187-.10988.73745-.30546c.19559-.19559.30544-.46086.30544-.73745 0-.2766-.10985-.54187-.30544-.73746-.19558-.19558-.46085-.30546-.73745-.30546z",
    fill: "#9dafbc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d27785f549412e31715654e2edadec6b.svg";
export { ForwardRef as ReactComponent };